import { useSelector } from 'react-redux';

import Table from '@/components/Table/table';

import ClaimsSwitch from '@/components/claims/switch';
import { RootState } from '@/store/store.ts';

import { useIsProcess } from '@/hooks/useIsProcess';

const Main = () => {
  const {
    data: claims,
    loading,
    isProcess,
  } = useSelector((state: RootState) => state.claims);

  const { claimsData, columns } = useIsProcess({ claims, isProcess });

  return (
    <div>
      <div className="flex items-center justify-center mt-6">
        <ClaimsSwitch />
      </div>

      {loading ? (
        <p className="text-center mt-4">Indlæser data...</p>
      ) : (
        <Table data={claimsData} columns={columns} isSwitch={true} isImport={true}/>
      )}
    </div>
  );
};

export default Main;
